<h1 class="text-secondary text-sm px-3 pt-4">
  Jouez le rôle de
  <strong>{{ supplierLabel }}</strong>
  face à l'API fournisseur : consultez ses expressions de besoin et ses commandes, puis répondez-y comme le ferait son
  logiciel. Les actions modifient réellement les données de cet environnement. Onglet réservé aux comptes Predik, masqué
  en production.
</h1>

<!-- Clé API -->
<div class="card mt-6 p-4">
  <h2 class="text-base font-medium m-0 mb-3">Clé API</h2>
  <div class="flex flex-col md:flex-row md:items-center gap-3">
    <mat-form-field class="flex-auto" appearance="outline">
      <mat-label>Clé API du fournisseur</mat-label>
      <input
        matInput
        [type]="showKey ? 'text' : 'password'"
        [ngModel]="apiKey"
        (ngModelChange)="onApiKeyChange($event)"
        autocomplete="off"
        spellcheck="false"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="showKey = !showKey"
        [matTooltip]="showKey ? 'Masquer la clé' : 'Afficher la clé'"
      >
        <mat-icon>{{ showKey ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="generateKey()"
      [disabled]="generatingKey || !supplierId"
      matTooltip="Crée une clé visible dans l'onglet API, révocable comme les autres"
    >
      Générer une clé de test
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="checkKey()"
      [disabled]="checkingKey || !apiKey"
      matTooltip="GET /supplier/v1/me"
    >
      Vérifier
    </button>
  </div>

  <ng-container *ngIf="keyIdentity">
    <base-banner-message
      *ngIf="keyIdentity.matchesSupplier"
      [text]="
        'Clé valide : tenant <strong>' +
        keyIdentity.tenant +
        '</strong>, fournisseur <strong>' +
        keyIdentity.supplier +
        '</strong>.'
      "
      [noMargin]="true"
    ></base-banner-message>
    <base-banner-message
      *ngIf="!keyIdentity.matchesSupplier"
      [text]="
        'Cette clé appartient au fournisseur <strong>' +
        keyIdentity.supplier +
        '</strong>, pas à celui affiché. Les appels porteront sur ses données.'
      "
      alertType="warn"
      [noMargin]="true"
    ></base-banner-message>
  </ng-container>
  <base-banner-message *ngIf="keyError" [text]="keyError" alertType="alert" [noMargin]="true"></base-banner-message>
</div>

<div class="mt-6 grid grid-cols-1 xl:grid-cols-3 gap-6 items-start">
  <div class="xl:col-span-2 min-w-0">
    <mat-button-toggle-group class="mb-4" [(ngModel)]="section" aria-label="Section">
      <mat-button-toggle value="tickets">Expressions de besoin</mat-button-toggle>
      <mat-button-toggle value="orders">Commandes</mat-button-toggle>
    </mat-button-toggle-group>

    <div *ngIf="!apiKey" class="card empty-state">Collez une clé API ou générez une clé de test pour commencer.</div>
    <ng-container *ngIf="apiKey">
      <vex-api-tester-tickets *ngIf="section === 'tickets'"></vex-api-tester-tickets>
      <vex-api-tester-orders *ngIf="section === 'orders'"></vex-api-tester-orders>
    </ng-container>
  </div>

  <vex-api-tester-journal class="min-w-0 xl:sticky xl:top-4"></vex-api-tester-journal>
</div>
